import { rolesEnum } from '@/helpers/Constants'
import httpClientWrapper from '@/helpers/HttpClientWrapper'
import jwtHelper from '@/helpers/JwtHelper'
import Evaluation from '@/model/Evaluation'
import PasswordRecoveryCodeDto from '@/model/PasswordRecoveryCodeDto'
import PasswordResetRequest from '@/model/PasswordResetRequest'
import UserJoinRequest from '@/model/UserJoinRequest'
import StringWrapper from '@/model/StringWrapper'
import Reward from '@/model/Reward'
import { useAuthStore } from '@/stores/auth'

const userService = {
    getUserInfo: getUserInfo,
    createJoinRequest: createJoinRequest,
    getAllUsers: getAllUsers,
    getUsers: getUsers,
    decorate: decorate,
    sendRecoveryCode: sendRecoveryCode,
    sendRecoveryCodeWithoutToken: sendRecoveryCodeWithoutToken,
    resetPassword: resetPassword,
    resetPasswordWithoutToken: resetPasswordWithoutToken,
    getPendingJoinRequests: getPendingJoinRequests,
    acceptJoinRequests: acceptJoinRequests,
    denyJoinRequests: denyJoinRequests,
    evaluateUser: evaluateUser,
    saveWill: saveWill,
    rewardUser: rewardUser,
    calculateRewardablePoints: calculateRewardablePoints,
    deleteAccount: deleteAccount
}

async function getUserInfo(userId) {
    const response = await httpClientWrapper.get(`/api/users?id=${userId}`, jwtHelper.makeHttpAuthorization())    
    decorate([response.result])
    return response.result
}

async function createJoinRequest(firstName, lastName, email, password) {
    return await httpClientWrapper.post('/api/joinRequest', new UserJoinRequest(firstName, lastName, email, password), jwtHelper.makeHttpAuthorization())
}

async function getAllUsers(filterAdmin) {
    const userResponse = await httpClientWrapper.get('/api/users', jwtHelper.makeHttpAuthorization())
    let users = userResponse.result.collection
    if (filterAdmin === true) {
        users = users.filter(u => !u.authorities.map(a => a.name).includes(rolesEnum.ROLE_ADMIN))
    }
    decorate(users)
    return users
}

async function getUsers(page, pageSize) {
    const response = await httpClientWrapper.get(`/api/users?page=${page}&pageSize=${pageSize}`, jwtHelper.makeHttpAuthorization())
    decorate(response.result.collection)
    return response.result
}

async function sendRecoveryCode() {
    await httpClientWrapper.get('/api/recoveryCode', jwtHelper.makeHttpAuthorization())
}

async function sendRecoveryCodeWithoutToken(email) {
    await httpClientWrapper.post('/api/recoveryCodeWithoutToken', new PasswordRecoveryCodeDto(email))
}

async function resetPassword(newPassword, checkCode) {
    return await httpClientWrapper.post('/api/resetPassword', new PasswordResetRequest(newPassword, checkCode), jwtHelper.makeHttpAuthorization())
}

async function resetPasswordWithoutToken(newPassword, checkCode, email) {
    return await httpClientWrapper.post('/api/resetPasswordWithoutToken', new PasswordResetRequest(newPassword, checkCode, email))
}

async function getPendingJoinRequests() {
    return await httpClientWrapper.get('/api/users/pendingJoinRequests', jwtHelper.makeHttpAuthorization())
}

async function acceptJoinRequests(requests) {
    return await httpClientWrapper.post('/api/users/acceptJoinRequests', requests, jwtHelper.makeHttpAuthorization())
}

async function denyJoinRequests(requests) {
    return await httpClientWrapper.post('/api/users/denyJoinRequests', requests, jwtHelper.makeHttpAuthorization())
}

async function evaluateUser(userId, operationId) {
    return await httpClientWrapper.post(`/api/users/evaluateUser`, new Evaluation(userId, operationId), jwtHelper.makeHttpAuthorization())
}

async function saveWill(will) {
    return await httpClientWrapper.post(`/api/users/will`, new StringWrapper(will), jwtHelper.makeHttpAuthorization())
}

async function rewardUser(userToBeRewarded, rewardPoints, rewardComment) {
    return await httpClientWrapper.post(`/api/users/reward`, new Reward(userToBeRewarded.id, rewardPoints, rewardComment), jwtHelper.makeHttpAuthorization())
}

async function deleteAccount() {
    const authStore = useAuthStore()
    return await httpClientWrapper.remove(`/api/users/${authStore.user.id}`, jwtHelper.makeHttpAuthorization())
}

function decorate(users) {
    for (const user of users) {
        user['fullName'] = user.firstname + ' ' + user.lastname
        if (user.imageUrl === null || user.imageUrl === undefined) {
            user.imageUrl = require('@/assets/avatar.png')
        }
        userService.calculateRewardablePoints(user)
    }
}

function calculateRewardablePoints(user) {
    if (user !== undefined && user !== null) {
        user.rewardablePoints = user.score + user.evaluationPoints - user.rewardedPoints
    }
}

export default userService